<figure kb-figure>
  <app-plain-video [section]="section" controls="full"></app-plain-video>

  @if (section.attributes.caption) {
    <figcaption [appEditorId]="section.editorIds?.caption">
      {{section.attributes.caption}}
    </figcaption>
  }
</figure>
